<template>
    <!-- We bind the visibility to the PWA state -->
    <Dialog
        v-model:visible="isNewVersionReady"
        :pt="{
            header: { class: 'hidden' },
            mask: {
                style: 'backdrop-filter: blur(10px); background-color: rgba(0, 0, 0, 0.25) !important',
            },
            content: {
                class: 'h-full lg:h-auto',
            },
        }"
        :class="[
            'min-w-[25vw]',
            'lg:max-w-[80vw]',
            'w-full',
            'lg:w-auto',
            'h-dvh max-h-[100dvh]',
            'lg:h-auto lg:max-h-[90dvh]',
            'rounded-none md:rounded-2xl shadow-2xl backdrop-blur-lg bg-white/90 dark:bg-gray-900/90 border border-white/10 transition-all duration-500',
        ]"
        :closable="false"
        contentClass="p-6 text-center"
        modal
    >
        <div class="flex flex-col items-center space-y-6 h-full justify-center">
            <div class="relative">
                <img src="/logo.webp" alt="logo" class="h-28 w-28 object-contain drop-shadow-lg" />
                <div
                    class="absolute inset-0 blur-3xl bg-gradient-to-r from-purple-500/30 via-pink-500/30 to-blue-500/30 rounded-full"
                ></div>
            </div>

            <p class="text-gray-800 dark:text-gray-100 text-xl font-semibold leading-relaxed">
                <span class="block mb-1 text-2xl font-bold text-primary-500">
                    ✨ {{ $t('progetto_aggiornato') }}
                </span>
                <span>{{ $t('testo_aggiornamento_app') }}.</span>
            </p>

            <div class="flex gap-4 justify-center">
                <Button
                    :label="$t('aggiorna')"
                    severity="primary"
                    icon="fa-solid fa-arrows-rotate"
                    class="!px-6 !py-3 !rounded-full !text-lg transition-transform duration-300 hover:scale-105"
                    @click="handleUpdate"
                />
            </div>
        </div>
    </Dialog>
</template>

<script setup>
/**
 * PWA Update Dialog (2026 Version)
 * Uses native Vite-PWA states to manage the update lifecycle.
 */
const { $pwa } = useNuxtApp();
const { t } = useI18n();

// This property becomes true automatically when a new Service Worker
// is downloaded and waiting to take over.
const isNewVersionReady = computed(() => $pwa?.needRefresh);

/**
 * Handles the update process:
 * 1. Sends SKIP_WAITING to the new Service Worker.
 * 2. Triggers the activation of new files.
 * 3. Automatically reloads the page.
 */
const handleUpdate = async () => {
    if ($pwa) {
        try {
            // This is the modern replacement for manual cache clearing
            await $pwa.updateServiceWorker();
        } catch (error) {
            console.error("Errore durante l'aggiornamento della PWA:", error);
            // Fallback: force a hard reload if updateServiceWorker fails
            window.location.reload(true);
        }
    }
};
</script>
